// Types.ts

// The reducer name used in your slice
export const REDUCER_NAME = "plugin";

// Plugin DTO type (data transferred from API)
export interface iPluginDTO {
  id: number;
  name: string;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}
export interface iWhatsAppDTO {
  id?: string;
  phoneNumber?: string;
   email?:string;
  secretKey?:string;
  isActive?: number;
  createdAt?: string;
  updatedAt?: string;
  vendorId?:string;
}
// Plugin slice state type
export interface iPluginState {
  isLoading: boolean;
  pluginList: iPluginDTO[];
   whatsAppDtata:null;
  errorMessage: string | null;
   googlePixelData: any | null;
    analyticsDashboardData: any | null;
    googleAnalyticsData: any | null;
    billinginvoice?: number;
    firebaseData: any | null;
    googlePluginData: any | null;
}
